require('normalize.css');
require('clarity-ui/dist/css/all/clarity.css');
require('styles/App.css');

import React from 'react';
import { connect } from 'react-redux';
import { dbFetch } from 'store/actions';
import dispatchQuery from 'helpers/dispatchQuery';
import clrSso from 'clarity-ui-sso';
import schemas from 'schemas';
import MainComponent from './main.layout';


/**
 * Top Level component.
 */
class MainContainer extends React.Component {

  fetchAuth () {
    const { dispatch } = this.props;
    this.fetchUserAccess(dispatch);
    this.fetchUser(dispatch);
  }

  fetchUser (dispatch) {
    dispatch(dbFetch(undefined, Object.assign({}, schemas, {user: schemas.user}), 'post', true, '/validate'));
  }

  fetchUserAccess (dispatch) {
    const accessQuery = {query: '{classifiersAccess: abstractClassifier {id}, entityRecommenderAccess: indexingClassifier {id}}'};
    dispatchQuery(dispatch, accessQuery, 'classifiersAccess');
  }

  logOut () {
    clrSso.logout();
  }

  /**
  * Render the component
  *
  * @return {JSX} JSX component markup.
  **/
  render () {
    const { location, children } = this.props;
    return (
      <MainComponent currentPathLocation={location} logOut={this.logOut.bind(this)} fetchAuth={this.fetchAuth.bind(this)}>
        { children }
      </MainComponent>
    )
  }
}

export default connect()(MainContainer);



// WEBPACK FOOTER //
// ./src/components/layouts/main.container.jsx